export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

// Player
export const PLAYER_SPEED = 300;
export const PLAYER_SHOOT_COOLDOWN = 500;
export const MAX_BULLETS = 3;
export const PLAYER_WIDTH = 96;    // doubled for larger face area
export const PLAYER_HEIGHT = 72;   // doubled for larger face area
export const PLAYER_CORE_RADIUS = 24;
export const PLAYER_BODY_SCALE = 0.4; // reduce collision box size

// Projectiles
export const BULLET_SPEED = 400;
export const BOMB_SPEED = 200;

// Bomb dropping configuration
export const BOMB_DROP_ENABLED = true; // Enable/disable alien bomb dropping
export const BOMB_DROP_BASE_CHANCE = 0.0002; // Base chance per alien per frame (level 1)
export const BOMB_DROP_LEVEL_INCREASE = 0.0005; // Increase per level

// Aliens
export const ALIEN_ROWS = 3;
export const ALIEN_COLS = 7;       // reduced further to fit larger sprites
export const ALIEN_SPACING_X = 90; // widened spacing for bigger aliens
export const ALIEN_SPACING_Y = 70;
export const ALIEN_START_Y = 100;
export const ALIEN_START_SPEED = 500; // ms per move
export const ALIEN_WIDTH = 88;     // doubled sprite size
export const ALIEN_HEIGHT = 64;    // doubled sprite size
export const ALIEN_CORE_RADIUS = 20;
export const ALIEN_BODY_SCALE = 0.7; // collision body width/height multiplier vs sprite
export const ALIEN_TINT_ALPHA = 0.3; // tint strength for alien faces (0-1)
export const ABDUCTION_THRESHOLD_Y = 500; // y level at which aliens trigger game over

// Game
export const MAX_LIVES = 3;
export const SHIELD_COUNT = 4;
export const SHIELD_Y = 480;
export const MAX_STORED_FACES = 20;

// Points
export const POINTS = {
  ALIEN_TOP: 30,
  ALIEN_MIDDLE: 20,
  ALIEN_BOTTOM: 10
};

// Colors
export const COLORS = {
  BACKGROUND: 0x000000,
  PLAYER: 0x00ff00,
  ALIEN: 0xff0000,
  BULLET: 0xffff00,
  BOMB: 0xff00ff,
  SHIELD: 0x00ff00,
  GREEN_TINT: 0x88ff88
};

// Game Mode System
export const AUTO_SWITCH_INTERVAL = 4; // Switch modes after this many levels
export const ENABLE_MANUAL_MODE_SWITCH = true; // Allow number keys to switch modes

// Galaga Mode (Game 2) Settings
export const GALAGA_FORMATION_SPEED = 60; // pixels per second (smooth movement)
export const GALAGA_WAVE_MIN_INTERVAL = 2000; // ms between wave launches
export const GALAGA_WAVE_MAX_INTERVAL = 5000; // ms between wave launches
export const GALAGA_WAVE_MIN_SIZE = 2; // min aliens per wave
export const GALAGA_WAVE_MAX_SIZE = 6; // max aliens per wave
export const GALAGA_ATTACK_SPEED = 200; // pixels per second during attack
export const GALAGA_RETURN_SPEED = 150; // pixels per second when returning to formation
export const GALAGA_MAX_SIMULTANEOUS_WAVES = 3; // Performance limit

// Controller Default Button Indices
// These are the standard gamepad button mappings for most controllers
export const DEFAULT_CONTROLLER_FIRE_BUTTON = 0; // A button / Cross button
export const DEFAULT_CONTROLLER_BACK_BUTTON = 1; // B button / Circle button
export const DEFAULT_CONTROLLER_START_BUTTON = 11; // Start button (sometimes 9)
